import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import Footer from "../components/Footer";
import HeaderOthers from "../components/HeaderOthers";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "60px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    textAlign: "center",
  },

  content: {
    fontSize: "1rem",
    marginBottom: "20px !important",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px !important",
    fontWeight: "500 !important",
  },

  icon: {
    marginRight: 10,
    position: "relative",
    top: 5,
  },
  select: {
    marginBottom: 30,
  },
  footer: {
    marginTop: "-80px",
  },
  note: {
      backgroundColor: "#e8f4f8",
      padding: "10px",
      borderLeft: "4px solid #007bff",
      margin: "10px 0",
      fontStyle: "italic"
  }
}));

const PrivacyPolicy = () => {
  const classes = useStyle();

  useEffect(() => {
    window.scrollTo(0, -1);
  }, []);

  return (
    <>
      <HeaderOthers title="Privacy Policy" />
      <div className={classes.root}>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item md={12}>
              <Typography className={classes.title}>
                ST Pay Privacy Policy
              </Typography>

              <p>
                This Privacy Policy outlines how ST Pay collects, processes,
                stores and protects the personal data ("Personal Data") of its
                users (“Users”) across all its digital services. It applies to
                all users of ST Pay’s website, mobile application, and
                associated services (the “Platform”). Please read this Privacy
                Policy carefully to understand how your personal data is handled
                in compliance with applicable laws and our internal practices.
              </p>

              <h2>1. Scope and Applicability</h2>
              <p>
                By using our Platform, you agree to the terms of this Privacy
                Policy. We may collect certain personally identifiable
                information (PII), including but not limited to National ID,
                passport number, driver's license, TIN, and bank account details
                to ensure regulatory compliance and mitigate risks related to
                fraud, money laundering and terrorism financing.
              </p>


              <h2>2. Information We Collect</h2>
              <h3>a. Personal Information</h3>
              <p>When you register or use ST Pay, we may collect:</p>
              <ul>
                <li>Full name</li>
                <li>Mobile number</li>
                <li>Email address</li>
                <li>National ID (NID)</li>
                <li>Passport number</li>
                <li>Birth registration number</li>
                <li>Other identifying documents as required</li>
              </ul>
              <div className={classes.note}>
                <strong>Note: </strong>This data is securely stored and not sold, traded, or
                shared with unrelated third parties without your consent.
              </div>

              <h3>b. Device Information</h3>
              <p>
                We collect data about your device and interactions with the
                Platform, including:
              </p>
              <ul>
                <li>Device ID and type</li>
                <li>Operating system and version</li>
                <li>Connection and browser details</li>
              </ul>

              <h3>c. Transactional Data</h3>
              <p>
                All financial transactions are logged to ensure compliance with
                Bangladesh's:
              </p>
              <ul>
                <li>Money Laundering Prevention Act, 2012</li>
                <li>Anti-Terrorism Act, 2009</li>
                <li>And other applicable laws and regulations.</li>
              </ul>
              <p>
                Unusual or high-volume transactions may trigger additional
                background checks.
              </p>

              <h3>d. SMS Permission</h3>
              <p>We access SMS for OTP verification only during:</p>
              <ul>
                <li>Account registration</li>
                <li>Logging in from a new device</li>
              </ul>

              <h3>e. Log Data</h3>
              <p>We may collect:</p>
              <ul>
                <li>IP address</li>
                <li>Device name and OS</li>
                <li>App configuration and usage timestamp</li>
                <li>Diagnostic and crash data</li>
              </ul>

              <h3>f. Web Usage & Cookies</h3>
              <p>To improve service delivery, we track:</p>
              <ul>
                <li>IP and browser data</li>
                <li>Referrer URLs</li>
                <li>Session cookies, web beacons and similar technologies</li>
              </ul>

              

              <h2>3. Use of Collected Data</h2>
              <p>We use your data to:</p>
              <ul>
                <li>Deliver secure and personalized services</li>
                <li>Prevent fraudulent or illegal activities</li>
                <li>Investigate suspicious transactions or user complaints</li>
                <li>Ensure compliance with financial regulations</li>
                <li>Support audits and regulatory inspections</li>
              </ul>
              <p>
                ST Pay communicates with you using the contact information you
                provide for service updates, transaction alerts and compliance
                verification.
              </p>

              

              <h2>4. Sharing and Disclosure of Information</h2>
              <p>ST Pay may share your data with:</p>
              <ul>
                <li>
                  Government or regulatory authorities upon verified legal
                  request.
                </li>
                <li>
                  Partner banks, payment gateways, and financial institutions
                  for processing services.
                </li>
                <li>
                  Third-party vendors performing operational services (e.g.,
                  KYC, fraud prevention, analytics).
                </li>
                <li>
                  Affiliates and partners, where legally permitted and
                  necessary.
                </li>
              </ul>
              <p>We may also disclose data:</p>
              <ul>
                <li>
                  During business mergers, acquisitions, or restructuring.
                </li>
                <li>When legally obligated (e.g., court order)..</li>
                <li>To prevent imminent physical or financial harm</li>
              </ul>

              

              <h2>5. Access and Correction</h2>
              <p>Users can:</p>
              <ul>
                <li>
                  Access and update their personal information via their account
                  settings.
                </li>
                <li>
                  Request correction of inaccurate or incomplete information.
                </li>
                <li>
                  Contact us for data correction (administrative fees may apply).
                </li>
              </ul>

            

              <h2>6. Data Storage and Transfer</h2>
              <p>
                Your data is stored securely on servers located in Bangladesh.
                While we implement robust security practices, transmission over
                the Internet may still carry risks. Users are responsible for
                maintaining the confidentiality of their login credentials.
              </p>

              

              <h2>7. Service Providers</h2>
              <p>We may engage third-party providers to:</p>
              <ul>
                <li>Deliver services on our behalf</li>
                <li>Conduct fraud or risk assessments</li>
                <li>Provide technical or support services</li>
              </ul>
              <p>
                These parties are contractually obligated to protect your data
                and cannot use it for unrelated purposes.
              </p>

              

              <h2>8. Security Measures</h2>
              <p>We employ industry-standard security mechanisms including:</p>
              <ul>
                <li>Encryption</li>
                <li>Secure authentication</li>
                <li>Regular audits</li>
              </ul>
              <p>
                Protect your account with a strong password and/or PIN. Do not
                share credentials. You are responsible for any actions taken
                under your login.
              </p>

              

              <h2>9. Links to External Sites</h2>
              <p>
                Our Platform may contain links to third-party websites. We are
                not responsible for the content or privacy practices of these
                sites. Please review their privacy policies before interacting.
              </p>

              

              <h2>10. Mergers and Acquisitions</h2>
              <p>
                In the event of a merger or acquisition, your data may be
                transferred to the new entity which will be required to comply
                with this Privacy Policy.
              </p>

              

              <h2>11. Updates to This Privacy Policy</h2>
              <p>
                ST Pay may revise this Privacy Policy at any time. Updated terms
                will become effective immediately upon posting on this page. By
                continuing to use our services after any such update, you
                acknowledge and agree to the revised Privacy Policy. We
                encourage you to review this page periodically for any changes.
              </p>

              <br/><br/>


            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>

      <style jsx={true}>{`
        h4 {
          font-size: 22px;
          margin-top: 40px;
          margin-bottom: -10px;
        }

        ul > li {
          padding-bottom: 15px;
        }

        ul > li::marker {
          font-size: 22px;
        }
      `}</style>
    </>
  );
};

export default PrivacyPolicy;
